module.exports = __webpack_public_path__ + "static/media/YM65_3.8c5de93c.jpg";